export default "__VITE_ASSET__CL$SGQ8Z__"